import {ENV_KEY} from "../../global/env";

export const AUTH_TOKEN = `${ENV_KEY}-cono-auth-token`;
export const nonce = 987;
export const key = '9z$C&F)J@NcRfUjXn2r5u7x!A%D*G-KaPdSgVkYp3s6v9y/B?E(H+MbQeThWmZq4\n';
export const maxLengthInput = 300;
export const maxLengthTextArea = 1000;